import { useCallback, useEffect, useMemo, useState } from "react";
import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";
import { IOptions } from "components/DropdownSelect";

export function useParceirosDespachante(idDespachante: number | null) {
  const [parceiros, setParceiros] = useState<any[]>([]);
  const [parceirosOptions, setParceirosOptions] = useState<IOptions[]>([]);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  const api = useMemo(() => AxiosRequest.makeApi(), []);

  const listarTodosParceiros = useCallback(
    async (despachante: number) => {
      try {
        const { status, data } = await api.get(
          `/empresa/despachante/${despachante}/parceiros`
        );
        const rersponse = new HttpResponse(false, status, data);
        setError(rersponse);
        setParceiros(data);
        criarOptionsParceiros(data);
        return rersponse;
      } catch (error: IHttpError<IData, any> | any) {
        criarOptionsParceiros([]);
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      }
    },
    [api]
  );

  useEffect(() => {
    if (!idDespachante && idDespachante != 0) {
      setParceiros([]);
      criarOptionsParceiros([]);
      return;
    }

    listarTodosParceiros(idDespachante);
  }, [idDespachante, listarTodosParceiros]);

  function criarOptionsParceiros(parceiros: any[]) {
    const optionsParceiros = parceiros.map((item) => ({
      value: item.id,
      label: item.nomeFantasia,
    }));

    setParceirosOptions(optionsParceiros);
  }

  return {
    parceiros,
    error,
    parceirosOptions,
    listarTodosParceiros,
  };
}
